
export const seasonAction = (year) => {
    return {type: 'GET_YEAR', payload: year}
}